import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getUniversitiesList
 * @param pageNo - The page number to fetch
 * @param perPage - Number of items per page
 * @param search - Optional search query string
 * @description This function will fetch the universities list with optional search.
 */
export const getUniversitiesList = (pageNo, perPage, search = '') => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/basic_universities?page=${pageNo}&perpage=${perPage}`;
  if (search) {
    url += `&name=${encodeURIComponent(search)}`;
  }

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function addUpdateUniversity
 * @param params
 * @description This function will add or update a university.
 */
export const addUpdateUniversity = params => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/basic_universities${
    params.id ? `/${params.id}` : ""
  }`;

  if (params.id) {
    return axios.put(url, params, {
      headers: getAuthHeaders()
    });
  } else {
    return axios.post(url, params, {
      headers: getAuthHeaders()
    });
  }
};
